<button
  epg-icon-button
  class="epg-user-menu-portal-button"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="toggleOverlay()"
  aria-label="Open user menu"
>
  <mat-icon>menu</mat-icon>
</button>

<ng-template
  [cdk-connected-overlay]
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="closeOverlay()"
>
  <div class="epg-user-menu-container">
    <ng-content epg-user-profile-info></ng-content>
    <ng-content epg-language-selector></ng-content>
    <ng-content epg-user-menu-selection></ng-content>
  </div>
</ng-template>
